<template>
  <modal :modal-key="'post_game_modal'" :class-style="determineWinnerCSSClass"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ isGameWinner ? getTranslations.home_modals_post_game_congratz :
        getTranslations.home_modals_post_game_too_bad }}
        <br>{{ isGameWinner ? getTranslations.home_modals_post_you_won_the_game :
        getTranslations.home_modals_post_you_lost_the_game }}</h1>
      <ul>
        <li>
          <img :src="playersDetails.homePlayerAvatar" alt="">
          <span class="name">{{ playersDetails.homePlayerUsername }}</span>
          <div class="postgame_user">
            <star v-if="!isHomePlayer" :action-on-click="markFavorite"
                  :is-checked="isFavorite(playersDetails.homePlayerUsername)"
                  :key-id="_uid"/>
          </div>
        </li>
        <li class="trophy">
          <img src="static/images/trophy.png" alt="">
          <div class="score"><span>{{ homePlayerRoundScore }}</span>-<span>{{ awayPlayerRoundScore }}</span></div>
        </li>
        <li>
          <img :src="playersDetails.awayPlayerAvatar" alt="">
          <span class="name">{{ playersDetails.awayPlayerUsername }}</span>
          <div class="postgame_user">
            <star v-if="isHomePlayer" :action-on-click="markFavorite"
                  :is-checked="isFavorite(playersDetails.awayPlayerUsername)"
                  :key-id="_uid"/>
          </div>
        </li>
      </ul>
    </template>
    <template slot="body">
      <div class="new_game_buttons_section ">

        <div class="btn_left rematch"><p>{{ getTranslations.home_post_game_rematch }}</p><a @click="checkGameAvailability(true)"
                                                         style="cursor:pointer"><img src="static/images/rematch.svg"
                                                                                     alt=""></a></div>
        <div class="btn_right"><p>{{ getTranslations.home_post_game_change_opponent }}</p><a @click="checkGameAvailability(false)"
                                                          style="cursor:pointer"><img
          src="static/images/change_opponent.svg" alt=""></a>
        </div>
      </div>
      <h2 class="modal_sub">{{ getTranslations.home_modals_post_game_bonus_points_earned }}</h2>
      <ul class="buttons">
        <li><span class="score-lbl">{{ correctAnswersPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_correct_answers }}</span>
        </li>
        <li><span class="score-lbl" style="background: #609f94">{{ roundsVictoryPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_rounds_victory }}</span>
        </li>
        <li><span class="score-lbl" style="background: #aa4225">{{ gameVictoryPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_game_victory }}</span>
        </li>
        <li><span class="score-lbl" style="background: #16a085">{{ totalEarnedPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_total_earned }}</span>
        </li>
      </ul>
      <div v-if="!activeAddOnGameButton()" class="donut-chart">
        <div class="games-left donut-chart__info info_align" v-if="!userLeveledUp"><span class="num">{{ gameWinsToLevelUp }}</span>{{
          getTranslations.home_modals_post_game_games_to_level_up }}
        </div>
        <div id="level_chart" class="donut-size donut-cont">
          <div class="pie-wrapper">
                <span class="label">
                  <span class="smaller">{{ getTranslations.home_modals_post_game_level }}</span><span class="num">{{ currentLevel }}</span>
                </span>
            <div class="pie">
              <div class="left-side half-circle"></div>
              <div class="right-side half-circle"></div>
            </div>
            <div class="shadow"></div>
          </div>
        </div>
        <div class="games-played donut-chart__info" v-if="!userLeveledUp"><span class="num">{{ gamesWon }}</span>{{ getTranslations.home_modals_post_game_games_played }}</div>
      </div>
      <div v-else class="new_game_buttons_section">
        <h2>{{ getTranslations.home_modals_post_game_score_penalty }}</h2>
        <button v-if="activeAddOnGameButton()" type="button" class="btn2 btn2--small_for_addgame btn2--std" @click.prevent="$emit('playPostGameAddOn')">{{ getTranslations.home_modals_post_game_play_now }}</button>
        <br> <br>
      </div>
    </template>
  </modal>
</template>

<script>
/* eslint no-console: "off", curly: [2, "multi"], no-lonely-if: "error" */
import { mapGetters, mapState, mapActions } from 'vuex';
import { Howl } from 'howler';
import { pieChartAnimation } from '@/common/jQuery';
import Star from '@/components/home/shared/Star';
import Modal from '@/components/home/modals/shared/GenericModal';
import { ChecksToStartNewGame } from '@/common/mixins/rematch/rematch';

export default {
  name: 'post-game',
  components: {
    Star,
    Modal,
  },
  mixins: [ChecksToStartNewGame],
  data() {
    return {
      correctAnswersPoints: 0,
      roundsVictoryPoints: 0,
      gameVictoryPoints: 0,
      totalEarnedPoints: 0,
      currentLevel: 0,
      gameWinsToLevelUp: 0,
      gamesWon: 0,
      gameWonSound: new Howl({
        src: ['static/sounds/GameWin.ogg', 'static/sounds/GameWin.mp3'],
      }),
      gameLostSound: new Howl({
        src: ['static/sounds/LoseGame.ogg', 'static/sounds/LoseGame.mp3'],
      }),
    };
  },
  created() {
    if (this.soundsOn)
      if (this.isGameWinner)
        this.gameWonSound.play();
      else
        this.gameLostSound.play();
    console.log('in PostGame created hook:');
    this.correctAnswersPoints = this.isHomePlayer ? this.homePlayerCorrectAnswersPoints : this.awayPlayerCorrectAnswersPoints;
    this.roundsVictoryPoints = this.isHomePlayer ? this.homePlayerRoundVictoriesPoints : this.awayPlayerRoundVictoriesPoints;
    this.gameVictoryPoints = this.isHomePlayer ? this.homePlayerGameVictoryPoints : this.awayPlayerGameVictoryPoints;
    this.totalEarnedPoints = this.isHomePlayer ? this.homePlayerTotalEarnedPoints : this.awayPlayerTotalEarnedPoints;
    this.currentLevel = this.isHomePlayer ? this.homePlayerCurrentLevel : this.awayPlayerCurrentLevel;
    this.gameWinsToLevelUp = this.isHomePlayer ? this.homePlayerGameWinsToLevelUp : this.awayPlayerGameWinsToLevelUp;
    this.gamesWon = this.isHomePlayer ? this.homePlayerGamesWon : this.awayPlayerGamesWon;
  },
  mounted() {
    setTimeout(() => {
      pieChartAnimation('#level_chart', this.getGamesWonRatio());
    }, 100);
  },
  methods: {
    ...mapActions('users', [
      'markFavoriteUser',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    markFavorite() {
      this.markFavoriteUser(this.isHomePlayer ? this.playersDetails.awayPlayerUsername : this.playersDetails.homePlayerUsername);
    },
    isFavorite(username) {
      return (this.favoriteUsers[username] ? this.favoriteUsers[username].isFavorite : false);
    },
    activeAddOnGameMode() {
      return this.addOnMode.hide;
    },
    activeAddOnGameButton() {
      return !this.addOnMode.hide;
    },
    checkGameAvailability(isRematch) {
      /* eslint-disable */
      if (this.getUserAvailableGames === 0) {
        sessionStorage.removeItem('zeroBalancePopUp');
        console.log('going back to home page');
        this.$router.push('/home');
      } else {
        if (!isRematch) {
          this.$router.push('/home/favoriteUsers');
        } else {
          this.checkGameValidations(true, this.isHomePlayer ? this.playersDetails.awayPlayerUsername : this.playersDetails.homePlayerUsername, this.isHomePlayer ?
            this.playersDetails.awayPlayerAvatar : this.playersDetails.homePlayerAvatar, this.isHomePlayer ? this.playersDetails.awayPlayerLevel : this.playersDetails.homePlayerLevel);
        }
      }
    },
    getGamesWonRatio() {
      return ((this.gamesWon / (this.gameWinsToLevelUp + this.gamesWon)) * 100).toFixed(2);
    },
  },
  computed: {
    ...mapState('common', [
      'soundsOn',
      'addOnMode',
    ]),
    ...mapState('users', [
      'favoriteUsers',
    ]),
    ...mapState('game', [
      'playersDetails',
      'homePlayerRoundScore',
      'homePlayerCorrectAnswersPoints',
      'homePlayerRoundVictoriesPoints',
      'homePlayerGameVictoryPoints',
      'homePlayerTotalEarnedPoints',
      'homePlayerCurrentLevel',
      'homePlayerGameWinsToLevelUp',
      'homePlayerGamesWon',
      'awayPlayerRoundScore',
      'awayPlayerCorrectAnswersPoints',
      'awayPlayerRoundVictoriesPoints',
      'awayPlayerGameVictoryPoints',
      'awayPlayerTotalEarnedPoints',
      'awayPlayerCurrentLevel',
      'awayPlayerGameWinsToLevelUp',
      'awayPlayerGamesWon',
      'userLeveledUp',
    ]),
    ...mapGetters('common', [
      'getUserAvailableGames',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
      'isGameWinner',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    determineWinnerCSSClass() {
      return 'modal--postgame'.concat((this.isHomePlayer && this.isGameWinner) || (!this.isHomePlayer && !this.isGameWinner) ? ' player1' : ' player2');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/PostGame.vue